module.exports = __webpack_public_path__ + "static/media/GBlack.1e5abc45.jpg";